import { INIT_PAGE_STATE } from "../../constant/constant";

export const BLOB_SETTING_GET_LIST = "BLOB_SETTING_GET_LIST";
export const BLOB_SETTING_GET_LIST_SUCCESS = "BLOB_SETTING_GET_LIST_SUCCESS";
export const BLOB_SETTING_GET_LIST_ERROR = "BLOB_SETTING_GET_LIST_ERROR";
export const BLOB_SETTING_ADD_EDIT = "BLOB_SETTING_ADD_EDIT";
export const BLOB_SETTING_SAVE_ADD_EDIT = "BLOB_SETTING_SAVE_ADD_EDIT";
export const BLOB_SETTING_SAVE_ADD_EDIT_SUCCESS = "BLOB_SETTING_SAVE_ADD_EDIT_SUCCESS";
export const BLOB_SETTING_SAVE_ADD_EDIT_ERROR = "BLOB_SETTING_SAVE_ADD_EDIT_ERROR";
export const BLOB_SETTING_DELETE = "BLOB_SETTING_DELETE";
export const BLOB_SETTING_DELETE_SUCCESS = "BLOB_SETTING_DELETE_SUCCESS";
export const BLOB_SETTING_DELETE_ERROR = "BLOB_SETTING_DELETE_ERROR";
export const BLOB_SETTING_SET_BLOCKIR_STATUS = "BLOB_SETTING_SET_BLOCKIR_STATUS";
export const BLOB_SETTING_SET_BLOCKIR_STATUS_SUCCESS = "BLOB_SETTING_SET_BLOCKIR_STATUS_SUCCESS";

/**
 * Request to load blob settings.
 * @param {Object} p - Parameters (e.g., filters, pagination).
 * @returns {{ type: string, payload: Object }}
 */
export const loadBlobSetting = (p) => {
  const param = {
    ...{
      selectedPage: 1,
      filter: null,
      orderBy: "id",
      sortedBy: "desc",
      limit: INIT_PAGE_STATE.pageSizes[0],
    },
    ...p,
  };
  return {
    type: BLOB_SETTING_GET_LIST,
    payload: {
      selectedPage: param.selectedPage,
      filter: param.filter,
      orderBy: param.orderBy,
      sortedBy: param.sortedBy,
      limit: param.limit,
      showAll: param?.showAll,
    },
  };
};

/**
 * Successfully loaded blob settings.
 * @param {Object[]} data - List of blob setting records.
 */
export const loadBlobSettingSuccess = (data) => ({
  type: BLOB_SETTING_GET_LIST_SUCCESS,
  payload: data,
});

/**
 * Failed to load blob settings.
 * @param {Error|string} error - Error object or message.
 */
export const loadBlobSettingError = (error) => ({
  type: BLOB_SETTING_GET_LIST_ERROR,
  payload: error,
});

/**
 * Add or edit a blob setting request.
 * @param {Object} item - Blob setting data.
 * @param {"add"|"edit"} [mode="add"] - Mode of operation.
 */
export const addEditBlobSetting = (item, mode = "add") => ({
  type: BLOB_SETTING_ADD_EDIT,
  payload: {
    item,
    mode,
  },
});

/**
 * Save blob setting request (add/edit).
 * @param {Object} item - Blob setting data to save.
 * @param {"add"|"edit"} [mode="add"] - Mode of operation.
 * @param {Object} history - History object for navigation.
 */
export const saveAddEditBlobSetting = (item, mode = "add", history) => ({
  type: BLOB_SETTING_SAVE_ADD_EDIT,
  payload: {
    item,
    mode,
    history,
  },
});

/**
 * Successfully saved blob setting.
 * @param {Object} data - Saved blob setting record.
 */
export const saveAddEditBlobSettingSuccess = (data) => ({
  type: BLOB_SETTING_SAVE_ADD_EDIT_SUCCESS,
  payload: data,
});

/**
 * Failed to save blob setting.
 * @param {Error|string} error - Error object or message.
 */
export const saveAddEditBlobSettingError = (error) => ({
  type: BLOB_SETTING_SAVE_ADD_EDIT_ERROR,
  payload: error,
});

/**
 * Delete blob setting request.
 * @param {Object} data - Blob setting record or identifier.
 * @param {boolean} [confirmed=false] - Whether deletion is confirmed.
 */
export const deleteBlobSetting = (data, confirmed = false) => ({
  type: BLOB_SETTING_DELETE,
  payload: {
    item: data,
    confirmed,
  },
});

/**
 * Successfully deleted blob setting.
 */
export const deleteBlobSettingSuccess = () => ({
  type: BLOB_SETTING_DELETE_SUCCESS,
});

/**
 * Failed to delete blob setting.
 * @param {Error|string} error - Error object or message.
 */
export const deleteBlobSettingError = (error) => ({
  type: BLOB_SETTING_DELETE_ERROR,
  payload: error,
});

/**
 * Set blocked status for a blob setting.
 * @param {Object} payload - Data to set blocked/unblocked status.
 */
export const setBlockedStatus = (payload) => ({
  type: BLOB_SETTING_SET_BLOCKIR_STATUS,
  payload
});

/**
 * Successfully updated blocked status for blob setting.
 * @param {Object} payload - Updated blocked status data.
 */
export const setBlockedStatusSuccess = (payload) => ({
  type: BLOB_SETTING_SET_BLOCKIR_STATUS_SUCCESS,
  payload
});
